import { useParams } from "react-router-dom"
import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { ItemSection } from "../components/single-product/ItemSection"
import { SectionTitle } from "../components/global/SectionTitle"
import { Product } from "../components/global/Product"
import { useContext, useEffect, useState } from "react"
import { ProductsContext } from "../contexts/ProductsContext"
import "./singleProduct.css"

export function SingleProduct() {
    const { id } = useParams()

    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    const [product, setProduct] = useState(null)

    useEffect(() => {
        if(products) {
            const findProduct = products.find(e => e._id === id)
            setProduct(findProduct)
        }
    }, [products])

    return (
        <div className="single-product mx-auto">

            <Breadcrumbs dynamicPath={product && product.title} />

            <ItemSection />

            <div className="pt-5">
                <SectionTitle title="Related Items" />

                <div className="d-flex flex-wrap my-5 pb-5 related-items">
                    {
                        products && product && products.filter(
                            a => a.category === product.category && a._id !== id
                        ).map((e, i) => (
                            <Product
                                key={i}
                                id={e._id}
                                name={e.title}
                                image={e.image}
                                regularPrice={e.regularPrice}
                                salePrice={e.salePrice}
                                discount={e.discount}
                                newProduct={e.new}
                                rating={e.rating.rate}
                                reviews={e.rating.reviews}
                            />
                        ))
                    }
                </div>

            </div>

        </div>
    )
}